import CutileiLogo from 'icons/logo-cutilei-simple.png'

import {
  Container,
  Row,
  Image,
  InfoText
} from './styles'

export default function Member ({
  data: member,
  onSelect: handleSelect = () => null
}) {
  return (
    <Container onClick={() => handleSelect (member)}>
      <Row>
        <Image src={member.profile_picture ?? CutileiLogo}/>
        <InfoText>
          {member.name}
        </InfoText>
      </Row>
    </Container>
  )
}
